module.exports = __webpack_public_path__ + "img/bule5.92cbb264.png";